;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/chat/:id\",\"regex\":\"^/chat/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/customers/:id\",\"regex\":\"^/customers/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/customers/:id/contacts\",\"regex\":\"^/customers/([^/]+)/contacts$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/customers/:id/files\",\"regex\":\"^/customers/([^/]+)/files$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/customers/:id/files/:fileId\",\"regex\":\"^/customers/([^/]+)/files/([^/]+)$\",\"paramNames\":[\"id\",\"fileId\"],\"hasOptionalPrefix\":false},{\"path\":\"/customers/:id/notes\",\"regex\":\"^/customers/([^/]+)/notes$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/customers/:id/tasks\",\"regex\":\"^/customers/([^/]+)/tasks$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/plugins/:id\",\"regex\":\"^/plugins/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/tasks/:id\",\"regex\":\"^/tasks/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/agents\"},{\"path\":\"/chat\"},{\"path\":\"/customers\"},{\"path\":\"/dev/scrape\"},{\"path\":\"/members\"},{\"path\":\"/memories\"},{\"path\":\"/plugins\"},{\"path\":\"/settings\"},{\"path\":\"/tasks\"},{\"path\":\"/tasks/new\"},{\"path\":\"/billing\"},{\"path\":\"/billing/success\"},{\"path\":\"/dev/onboarding\"},{\"path\":\"/onboarding\"},{\"path\":\"/onboarding/success\"},{\"path\":\"/onboarding/welcome\"},{\"path\":\"/accept-invite\"},{\"path\":\"/account-conflict\"},{\"path\":\"/join\"},{\"path\":\"/join/blocked\"},{\"path\":\"/login\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.2.4";globalThis["_sentryRewritesTunnelPath"] = "/monitoring";import * as Sentry from "@sentry/nextjs";
import posthog from "posthog-js";

const sentryDsn = process.env.NEXT_PUBLIC_SENTRY_DSN;
const isLocalRuntime = process.env.NODE_ENV === "development";
const sentryEnabled =
  Boolean(sentryDsn) &&
  (!isLocalRuntime || process.env.NEXT_PUBLIC_SENTRY_ENABLED === "true");

if (sentryEnabled) {
  Sentry.init({
    dsn: sentryDsn,
    environment:
      process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT ??
      process.env.NEXT_PUBLIC_DEPLOY_ENVIRONMENT ??
      process.env.NEXT_PUBLIC_VERCEL_ENV ??
      process.env.NODE_ENV,
    sendDefaultPii: true,
    tracesSampleRate: process.env.NODE_ENV === "development" ? 1.0 : 0.1,
    enableLogs: true,
    integrations: [
      Sentry.replayIntegration({
        maskAllText: true,
        maskAllInputs: true,
        blockAllMedia: true,
      }),
    ],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;

const posthogToken = process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN;
const deployEnvironment =
  process.env.NEXT_PUBLIC_DEPLOY_ENVIRONMENT ??
  process.env.NEXT_PUBLIC_VERCEL_ENV ??
  process.env.NODE_ENV ??
  "unknown";

if (posthogToken && !isLocalRuntime) {
  posthog.init(posthogToken, {
    api_host: "/ingest",
    ui_host: "https://us.posthog.com",
    defaults: "2026-01-30",
    capture_exceptions: true,
    // Session replay also requires the project-level toggle:
    // PostHog → Settings → Session replay → "Record user sessions".
    // The SDK config below only controls what gets masked once it's on.
    session_recording: {
      // Deliberate: inputs stay visible. This is our own customers' CRM data
      // and we need to see who does what; only credentials are masked.
      // To hide a specific element later, add the `ph-no-capture` class.
      maskAllInputs: false,
      maskInputOptions: { password: true },
    },
    debug: process.env.NODE_ENV === "development",
  });
  posthog.register({ deploy_environment: deployEnvironment });
}
